// extracted by mini-css-extract-plugin
export default {"container":"UserFilterDialog_container__NhhUX"};